import { BehaviorSubject } from 'rxjs';

const defaultValue = {
  isOpen: false,
  onChangeAddress: null,
  changeLabel: 'Επιλέξτε άλλη διεύθυνση',
};

const subject = new BehaviorSubject(defaultValue);

const MasoutisAlertStore = {
  open(onChangeAddress = null, changeLabel = 'Επιλέξτε άλλη διεύθυνση') {
    subject.next({ isOpen: true, onChangeAddress, changeLabel });
  },

  close() {
    subject.next(defaultValue);
  },

  subscribe: setState => subject.subscribe(setState),

  getValue: () => subject.value,
};

export default MasoutisAlertStore;
